function setupWebViewJavascriptBridge(callback) {
	if (window.WebViewJavascriptBridge) {
		return callback(window.WebViewJavascriptBridge)
	}
	document.addEventListener(
		'WebViewJavascriptBridgeReady',
		function () {
			callback(window.WebViewJavascriptBridge)
		},
		false
	)
	if (window.WVJBCallbacks) {
		return window.WVJBCallbacks.push(callback)
	}
	window.WVJBCallbacks = [callback]
	const WVJBIframe = document.createElement('iframe')
	WVJBIframe.style.display = 'none'
	WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
	document.documentElement.appendChild(WVJBIframe)
	setTimeout(function () {
		document.documentElement.removeChild(WVJBIframe)
	}, 0)

}

setupWebViewJavascriptBridge(function (bridge) {
	try { // 此处try catch注意  android 有init初始化方法，必须调用 不调用后续注册的事件将无效 而IOS却没有init方法 调用会报错 所以得捕获异常
		bridge.init(function (message, responseCallback) {
			const data = {
				'Javascript Responds': '测试中文!'
			}
			responseCallback(data)
		})
	} catch (e) {
		console.log('---err->', e)
	}
	//
	// bridge.registerHandler('orderResultJsHandler', function(data, responseCallback) {
	//     //处理回调
	// });
})


export default setupWebViewJavascriptBridge